module.exports = __webpack_public_path__ + "static/media/RI-D6-10.1-074.f5c5b536.webp";